import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { bem } from 'helpers/class-name';
import Message from 'components/Message';
import Dot from 'components/Dot';
import EnableClassSwitch from '../EnableClassSwitch/EnableClassSwitch';
import messages from '../ClassesList.messages';
import './ClassesListRow.scss';

const { block, element } = bem('classes-list-row');

const ClassesListRow = ({ classTitleLink, showEnableClassToggle, updateIsClassEnabled, venueClass }) => {
  const { classId, className, disabled } = venueClass;

  return (
    <div className={block('grid grid--middle')} data-cypress="classes-detail-row">
      <div className={element('item', 'grid__item 1/2')}>
        <div className={element('cell', { extended: true })}>
          {!classTitleLink ? (
            className
          ) : (
            <Link to={classTitleLink(classId)} data-cypress="class-detail-row-link">
              <span className={element('link')}>{className}</span>
            </Link>
          )}
        </div>
      </div>
      <div className={element('item', 'grid__item 1/2', 'text--right', 'pr-large')}>
        {!showEnableClassToggle ? (
          <>
            <Dot className="ml-small" color={!disabled ? Dot.COLORS.GREEN : Dot.COLORS.RED} />
            <Message className="ml-small" message={!disabled ? messages.enabled : messages.disabled} />
          </>
        ) : (
          <EnableClassSwitch disabled={disabled} updateIsClassEnabled={updateIsClassEnabled} venueClass={venueClass} />
        )}
      </div>
    </div>
  );
};

ClassesListRow.propTypes = {
  venueClass: PropTypes.shape({ classId: PropTypes.number, className: PropTypes.string, disabled: PropTypes.bool }),
  classTitleLink: PropTypes.func,
  showEnableClassToggle: PropTypes.bool,
  updateIsClassEnabled: PropTypes.func,
};

export default ClassesListRow;
